import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NotificationMetadata {
  link: string;
  contact: string;
  severity: string;
}

export interface BannerNotification {
  id: string;
  message: string;
  isActive: boolean;
  startDate: string;
  endDate: string;
  metadata: NotificationMetadata;
  createdAt: string;
  updatedAt: string;
}

interface BannerNotificationsState {
  notifications: BannerNotification[];
}

const initialState: BannerNotificationsState = {
  notifications: [],
};

const bannerNotificationsSlice = createSlice({
  name: 'bannerNotifications',
  initialState,
  reducers: {
    setBannerNotifications(state, action: PayloadAction<BannerNotification[]>) {
      state.notifications = action.payload;
    },
  },
});

export const { setBannerNotifications } = bannerNotificationsSlice.actions;
export default bannerNotificationsSlice.reducer;
